import AccessWays from './access_ways/routes'
import ExchangeRate from './exchange_rate/routes'
import LossReasons from './loss_reasons/routes'
import Packages from './packages/routes'
import Pipelines from './pipelines/routes'
import ProductCategories from './product_categories/routes'
import PaymentMethods from './payment_methods/routes'
import Products from './products/routes'
import Segments from './segments/routes'
import Sources from './sources/routes'
import Suppliers from './suppliers/routes'
import Teams from './teams/routes'

export default [
    ...AccessWays,
    ...ExchangeRate,
    ...LossReasons,
    ...Packages,
    ...Pipelines,
    ...PaymentMethods,
    ...ProductCategories,
    ...Products,
    ...Segments,
    ...Sources,
    ...Suppliers,
    ...Teams
]



// WEBPACK FOOTER //
// ./src/modules/parameters/routes.js